



































import { Component, Vue, Prop } from "vue-property-decorator";
import ApolloClient from "../apollo";
import gql from "graphql-tag";
import ILabel from "../types/label";
import { copy } from "../util/object";

@Component
export default class LabelGroup extends Vue {
  @Prop({ default: () => [] }) value!: ILabel[];
  @Prop({ type: String, required: true }) item!: string;
  @Prop({ default: true }) allowRemove!: boolean;
  @Prop({ default: 5 }) limit!: number;

  get labels() {
    return this.value.sort((a, b) => a.name.localeCompare(b.name));
  }

  async removeLabel(id: string) {
    try {
      await ApolloClient.mutate({
        mutation: gql`
          mutation($item: String!, $label: String!) {
            removeLabel(item: $item, label: $label)
          }
        `,
        variables: {
          item: this.item,
          label: id,
        },
      });
      this.$emit(
        "input",
        copy(this.value).filter((x) => x._id !== id)
      );
    } catch (error) {}
  }
}
